module.exports = __webpack_public_path__ + "static/img/footer2.74bad8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer2.png
// module id = Mano
// module chunks = 1